'use client';
import LogApi from '@/api/common/log';
import {getTagSearchPath} from '@/components/main/directory/DirectoryCategoryListItem';
import {SoopUiImg} from '@/components/ui';
import useDirectoryStore from '@/stores/directory';
import {getLocationForTagClickLog} from '@/utils';
import {convertViewCnt} from '@/utils/main';
import {useState} from 'react';
import {Link} from 'react-router-dom';

const CategoryDetail = ({categoryInfo}) => {
  const [imageError, setImageError] = useState(false);
  const {selectedCategoryTab} = useDirectoryStore();
  const handleImageError = () => {
    setImageError(true);
  };

  /**
   * 이벤트 & 드롭스 태그 클릭 시 로그를 발송하는 함수
   */
  const handleOnClickEventTag = () => {
    LogApi.sendClickLog({
      codeType: 'tags',
      sendData: {
        location: getLocationForTagClickLog(location.pathname, location.search),
        contentsType: 'live',
        buttonType: 'drops_tags',
      },
    });
  };
  return (
    <>
      {categoryInfo && (
        <div className='list_detail'>
          <span className='thumb'>
            <SoopUiImg
              src={categoryInfo.cateImg}
              alt=''
              type={'poster'}
              onError={handleImageError}
            />
          </span>
          <div className='detail_box'>
            <p className='tit'>{categoryInfo.categoryName}</p>
            <span className='info'>
              <em>{convertViewCnt(categoryInfo.viewCnt)}</em>명 참여중
            </span>
            <div className='tag_wrap'>
              {!!categoryInfo.isDrops && (
                <Link
                  className='drops'
                  to={getTagSearchPath('드롭스')}
                  onClick={handleOnClickEventTag}>
                  <span>드롭스</span>
                </Link>
              )}
              {categoryInfo.fixedTags &&
                categoryInfo.fixedTags.length > 0 &&
                categoryInfo.fixedTags.map((item, idx) => (
                  <Link
                    key={idx}
                    to={getTagSearchPath(item, selectedCategoryTab)}>
                    {item}
                  </Link>
                ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default CategoryDetail;
